import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-print-common',
  templateUrl: './print-common.component.html',
  styleUrls: ['./print-common.component.css']
})
export class PrintCommonComponent {
  @Input() rowData: any;
  @Input() columns: any;

  // Print function
  printData(): void {
    const printContent = this.generatePrintTable(this.rowData, this.columns);
    
    // Open the print window
    const printWindow = window.open('', '_blank', 'width=600,height=400');
    
    if (printWindow) {  // Check if printWindow is not null
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error('Unable to open print window');
    }
  }
  

  // Helper function to generate the printable table
   generatePrintTable(rowData: any, columns: any): string {
    let tableContent = `<html><head><title>Print</title></head><body><h2>Details</h2><table border="1" cellpadding="5" cellspacing="0" style="width: 100%; font-family: Arial, sans-serif;">`;
  
    // Add table rows with headers in the first column and data in the second column
    tableContent += `<tbody>`;
    columns.forEach((col: any) => {
      tableContent += `<tr><td style="font-weight: bold;width: 30%">${col.header}</td><td>${rowData[col.key]}</td></tr>`;
    });
    tableContent += `</tbody>`;
  
    tableContent += `</table></body></html>`;
    return tableContent;
  }
  
}
